<div class="flex">
  <sbnb-subnav [header]="'OPERATIONS.OPERATIONS' | transloco">
    <sbnb-operations-subnav></sbnb-operations-subnav>
    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'statements-dashboard'"></sbnb-helptext-wrapper>
  </sbnb-subnav>

  <main class="subnav__exists flex-1" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <div class="w-full">
      <app-feature-flag-tabs class="w-full">
        <sbnb-page-header [parentPath]="'menu-mobile/ops-mobile'" navTabs>
          <div class="flex justify-center sbnbDesktop:justify-start sbnbDesktop:mb-8">
            <h2 class="mb-0 flex-1">Statements</h2>
          </div>
        </sbnb-page-header>
        <div class="flex mb-8">
          <h2 class="mb-0 flex-1">Statements</h2>
        </div>
      </app-feature-flag-tabs>

      <!-- filters -->
      <div>
        <sbnb-filter
          customEndpoint="/operations/v2/statements/filters"
          [sortByLabel]="false"
          [hideSaveSegment]="true"
          [defaultFilters]="activeFilters$ | async"
          (filterChanged)="activeFilters$.next($event)"
          (reset)="activeFilters$.next([])"></sbnb-filter>
      </div>
      <sbnb-statement-tabs></sbnb-statement-tabs>
    </div>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Operations'">
  <sbnb-operations-subnav></sbnb-operations-subnav>
</sbnb-mobile-sidebar>
